import React from 'react';
import { CloudImage } from '@components/CloudImage';
import { OurStorySectionContent } from './OurStorySectionContent';
import { OurStoryWrapper, CurlBox } from './OurStorySection.styles';

export const OurStorySectionMobile = () => {
  return (
    <OurStoryWrapper paddingTop={11} paddingBottom={9} paddingX={6}>
      <CurlBox>
        <CloudImage src="our-story/story/curl.svg" width="100%" height="100%" optimization="aggressive" />
      </CurlBox>
      <OurStorySectionContent />
    </OurStoryWrapper>
  );
};
